import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    fetchFeatureEnrollments,
    fetchFeatureEnrollmentsSuccess,
    fetchFeatureEnrollmentsError,
    fetchFeatureEnrollmentsReset,
} from '@perpay-web/fintech/actions/entities/featureEnrollments';
import { CANCELED } from '@perpay-web/fintech/constants/featureEnrollmentStatuses';
import {
    ALL_PERPAY_PLUS_VERSIONS,
    PERPAY_PLUS_SOLO,
} from '@perpay-web/fintech/constants/featureTypes';

const FetchFeatureEnrollmentsDataModule = createDataModule({
    dataRequest: fetchFeatureEnrollments,
    dataSuccess: fetchFeatureEnrollmentsSuccess,
    dataError: fetchFeatureEnrollmentsError,
    dataReset: fetchFeatureEnrollmentsReset,
});

const getRoot = (state) => state.dataModules.fetchFeatureEnrollments;
const initialValue = {
    featureEnrollments: [],
};

export const fetchFeatureEnrollmentsDataModule =
    FetchFeatureEnrollmentsDataModule({
        getRoot,
        initialValue,
    });

const getPerpayPlusEnrollments = (state) => {
    const { featureEnrollments } =
        fetchFeatureEnrollmentsDataModule.getData(state);
    const perpayPlusEnrollments = featureEnrollments.filter((enrollment) =>
        ALL_PERPAY_PLUS_VERSIONS.includes(enrollment.feature),
    );
    return perpayPlusEnrollments;
};

export const getHasEverOptedInToPerpayPlus = (state) => {
    const perpayPlusEnrollments = getPerpayPlusEnrollments(state);
    return Boolean(perpayPlusEnrollments.length);
};
export const getHasActiveNonSoloPerpayPlusEnrollment = (state) => {
    const perpayPlusEnrollments = getPerpayPlusEnrollments(state);
    return perpayPlusEnrollments.some(
        (enrollment) =>
            enrollment.feature !== PERPAY_PLUS_SOLO &&
            enrollment.status !== CANCELED,
    );
};

export const getHasPerpayPlusSoloEnrollment = (state) => {
    const perpayPlusEnrollments = getPerpayPlusEnrollments(state);
    return perpayPlusEnrollments.some(
        (enrollment) => enrollment.feature === PERPAY_PLUS_SOLO,
    );
};

export const getPerpayPlusSoloEnrollmentStatus = (state) => {
    const perpayPlusEnrollments = getPerpayPlusEnrollments(state);
    const soloEnrollment = perpayPlusEnrollments.find(
        (enrollment) =>
            enrollment.feature === PERPAY_PLUS_SOLO &&
            enrollment.status !== CANCELED,
    );
    if (!soloEnrollment) {
        return null;
    }
    return soloEnrollment.status;
};
